
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../util';
import DutySettingsButton from "./DutySettings/DutySettingsButton";
import DutyUi from "../../dutyui/DutyUi";
import InventoryComponent from '../inventory/inventory';
import CellUi from '../../cell/CellUi';

declare var window: WindowType;

type Tab = 'cell' | 'line' | 'duty' | 'inventory';

@Component({
  name: 'ConfigUi',
  components: {
    CellUi,
    DutySettingsButton,
    DutyUi,
    LineUi: require('../../line/line.vue.html').default,
    InventoryComponent,
  }
})
export default class ConfigUi extends Vue {
  selectedTab: Tab = 'cell';

  get tabs(): { tab: Tab, name: string }[] {
    const tabs: { tab: Tab, name: string }[] = [
      { tab: 'cell', name: this.$t('txtCell').toString() },
      { tab: 'line', name: this.$t(window.application.check2.isMaintenanceMode ? 'Lines' : 'txtArea').toString() },
      { tab: 'duty', name: this.$t('Duty').toString() },
    ];
    if (window.application.check2.isInventory) {
      tabs.push({ tab: 'inventory', name: this.$t('txtInventory').toString() });
    }
    return tabs;
  }

  mounted(): void {
    this.handleTabSelectTriggerByUrl();
  }

  onDutiesImported(): void {
    (this.$refs.dutyUi as DutyUi)?.fetchAndClear();
  }

  private handleTabSelectTriggerByUrl(): void {
    let url = new URL(window.location.href);
    if (url.searchParams.has('cell')) {
      this.selectedTab = 'cell';
    } else if (url.searchParams.has('duty')) {
      this.selectedTab = 'duty';
    }
  }
}
